import React from "react";
import KitchenDashboard from "./KitchenDashboard";

const DrinkKitchen = () => <KitchenDashboard kitchenType="drink" />;

export default DrinkKitchen;
